import React from "react";
import {
  LineChart,
  ReferenceDot,
  ReferenceLine,
  XAxis,
  YAxis,
  ResponsiveContainer
} from "recharts";
import animations from "../util/animations";
import format from "../util/format";
import theme from "../theme";
const {
  screen: { colors }
} = theme;

const xTicks = [-3, -2, -1, 1, 2, 3];
const yTicks = [-2, -1, 1, 2];

export default class extends React.Component {
  state = { time: 0 };

  static defaultProps = {
    numbers: [],
    movingNumbers: [],
    imagAxis: true,
    frameLength: 0,
    numbersAnimated: false,
    labels: true,
    xMax: 3.3
  };

  componentDidMount() {
    if (this.props.movingNumbers)
      animations.add(this, {
        key: "time",
        min: 0,
        max: 1,
        repeat: true,
        length: 90000,
        stepLength: this.props.frameLength
      });
  }
  componentWillUnmount() {
    animations.remove(this);
  }
  render() {
    const xMax = this.props.xMax;
    const yMax = (xMax / 12) * 8.5;
    const offset = xMax /3.3*0.2;
    const numberClass = this.props.numbersAnimated ? "fadeIn-20" : "";
    const imagClass = this.props.imagAnimated ? "fadeIn-20" : "";
    return (
      <div style={{ height: "100vh", maxHeight: "830px", fontSize: "130%" }}>
        <ResponsiveContainer>
          <LineChart data={[]}>
            <YAxis
              hide={true}
              dataKey="x"
              type="number"
              domain={[-yMax, yMax]}
            />
            <XAxis
              hide={true}
              dataKey="y"
              type="number"
              domain={[-xMax, xMax]}
            />
            <ReferenceLine y={0} stroke="black" />
            [ <ReferenceDot x={0} y={0} r={5} key={"d0_0"} fill="black" />,
            <ReferenceDot
              x={this.props.imagAxis ? -offset : 0}
              y={-offset}
              r={0}
              key={"t0_0"}
              label="0"
            />
            , ]
            {this.props.labels
              ? xTicks.map(v => [
                  <ReferenceDot
                    x={v}
                    y={0}
                    r={5}
                    key={"dx_" + v}
                    fill="black"
                  />,
                  <ReferenceDot
                    x={v}
                    y={-offset}
                    r={0}
                    key={"tx_" + v}
                    label={format(v, 0, true)}
                  />
                ])
              : null}
            {this.props.imagAxis ? (
              <ReferenceLine x={0} stroke="black" className={imagClass} />
            ) : null}
            {this.props.imagAxis
              ? this.props.labels
                ? yTicks.map(v => [
                    <ReferenceDot
                      x={0}
                      y={v}
                      r={5}
                      key={"dy_" + v}
                      fill="black"
                      className={imagClass}
                    />,
                    <ReferenceDot
                      x={-offset}
                      y={v}
                      r={0}
                      key={"ty_" + v}
                      label={format(0, v, true)}
                      className={imagClass}
                    />
                  ])
                : null
              : null}
            {[
              ...this.props.numbers,
              ...this.props.movingNumbers.map(v => v(this.state.time))
            ].map(([a, b, options], i) => [
              <ReferenceDot
                x={a}
                y={b}
                r={5}
                key={"dab_" + i}
                className={numberClass}
                fill={colors.highlight}
                {...options || {}}
              />,
              <ReferenceDot
                x={a + 0.05}
                y={b + 0.1}
                r={0}
                key={"tab_" + i}
                className={numberClass}
                label={format(a, b, true)}
                {...options || {}}
              />
            ])}
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
